import { render, staticRenderFns } from "./DisplayPlacements.vue?vue&type=template&id=66fdf10d&scoped=true&"
import script from "./DisplayPlacements.vue?vue&type=script&lang=js&"
export * from "./DisplayPlacements.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPlacements.vue?vue&type=style&index=0&id=66fdf10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fdf10d",
  null
  
)

export default component.exports